export const REPORT_TYPE = 'AI EOU';

export const BEAT_HR_TAB_ID = 'beatHrTabId';
export const RHYTHM_EVENT_TAB_ID = 'rhythmEventTabId';
export const STRIP_MANAGEMENT_TAB_ID = 'stripManagementTabId';
export const HR_SUMMARY_TAB_ID = 'hrSummaryTabId';
export const STRIP_MANAGEMENT_DEVICE_TAB_ID = 'stripManagementDeviceTabId';
export const BEAT_V_TEMPLATE_TAB_ID = 'beatVTeamplateTabId';
export const BEAT_S_TEMPLATE_TAB_ID = 'beatSTeamplateTabId';
